import React from 'react';
import { createDropdownClassName } from './dropdownStyles';

export const DropdownPopup: React.FC = ({ children }) => {
  return <div className={createDropdownClassName('popup')}>{children}</div>;
};
